import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import ActionButton from '../../../../ui/primitives/ActionButton';

const FileUploadJira = ({ enableDragAndDrop, loading, handleFiles }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    setError(null);
    handleFiles(files);
  };

  const handleFileChange = (e) => {
    setError(null);
    const files = Array.from(e.target.files);
    handleFiles(files);
  };

  const handleChooseFiles = () => {
    fileInputRef.current.click();
  };

  if (loading) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
        Uploading...
      </Typography>
    );
  }

  return (
    <>
      {enableDragAndDrop ? (
        <Typography
          component="div"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={handleChooseFiles}
          sx={{
            border: isDragging ? '2px dashed' : '2px dashed',
            borderColor: isDragging ? 'primary.main' : 'divider',
            borderRadius: 1,
            p: 2.5,
            textAlign: 'center',
            mb: 2,
            cursor: 'pointer',
            backgroundColor: isDragging ? 'action.hover' : 'transparent',
            transition: 'all 0.15s ease',
            '&:hover': {
              borderColor: 'primary.light',
              backgroundColor: 'action.hover',
            },
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Drag & drop or click to select files
          </Typography>
        </Typography>
      ) : (
        <ActionButton
          label="Attach files"
          icon={<Add />}
          intent="ghost"
          size="small"
          onClick={handleChooseFiles}
          sx={{ mr: 1 }}
        />
      )}

      <input
        type="file"
        multiple
        onChange={handleFileChange}
        style={{ display: 'none' }}
        ref={fileInputRef}
      />
      {error && (
        <Typography variant="caption" color="error.main">
          {error}
        </Typography>
      )}
    </>
  );
};

export default FileUploadJira;
